import { GridCellProps } from "@progress/kendo-react-grid";
import * as React from "react";
import { useContext } from "react";
import { ComboBoxCell } from "../../../../../../Layout/Grid/Cell/Default/ComboBoxCell";
import { EditProjectContext } from "../../../../EditProjectContext";

export function CrossingCountriesComboBoxCell(props: GridCellProps) {
  const { project } = useContext(EditProjectContext);

  const localizedData: { text: string; value: any }[] =
    project.CountryAutoCompleteElements?.map((item) => {
      return {
        text: item?.Name || "",
        value: item?.Name || -1,
      };
    }) || [];
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ComboBoxCell {...props} localizedData={localizedData} />;
}
